/**
 * Tracks who is acting for product analytics exclusion (admins + local hosts).
 * Synced from AuthContext; read by trackUxEvent / logEventSearch / PageViewTracker.
 */

import { isAdminRole } from '../services/userProfile';

let actorUid = null;
let actorRole = null;

const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '[::1]']);

/**
 * @param {{ uid?: string|null, role?: string|null }} [next]
 */
export function setAnalyticsActor(next = {}) {
  actorUid = next.uid ? String(next.uid) : null;
  actorRole = next.role ? String(next.role) : null;
}

/**
 * @returns {{ uid: string|null, role: string|null }}
 */
export function getAnalyticsActor() {
  return { uid: actorUid, role: actorRole };
}

/**
 * @returns {boolean}
 */
export function isLocalAnalyticsHost() {
  if (typeof window === 'undefined' || !window.location) return false;
  return LOCAL_HOSTS.has(window.location.hostname);
}

/**
 * Admins and local/dev hosts are excluded from product analytics.
 * @returns {boolean}
 */
export function shouldSkipAnalytics() {
  if (isAdminRole(actorRole)) return true;
  if (isLocalAnalyticsHost()) return true;
  return false;
}
